import provinceValidation from 'shared/utils/provinceValidation';
import * as Yup from 'yup';

export const validationSchema = Yup.object({
    address: Yup.array().of(
        Yup.object().shape({
            address: Yup.object().shape({
                country: Yup.string().required('Country is required'),
                province: provinceValidation
            })
        }))
})
